import { render, staticRenderFns } from "./ProductionSettings.vue?vue&type=template&id=772d7f04&scoped=true&"
import script from "./ProductionSettings.vue?vue&type=script&lang=js&"
export * from "./ProductionSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductionSettings.vue?vue&type=style&index=0&id=772d7f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d7f04",
  null
  
)

export default component.exports